import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectUser } from "../../redux/main/authSlice";
import { selectColorsSchema } from "../../redux/main/uiSlice";

const CustomerDashboard = () => {
  const user = useSelector(selectUser);
  const colorsSchema = useSelector(selectColorsSchema);

  useEffect(() => {
    document.title = "Dashboard Cliente | Installamelo";
  }, []);

  const cards = [
    {
      title: "Nuova Richiesta di Assistenza",
      description: "Crea una nuova richiesta di assistenza",
      icon: "fi fi-br-plus",
      link: "/customerAddEditAssistanceRequest",
      bgColor: colorsSchema ? colorsSchema[3] : "#3b82f6",
      iconBg: colorsSchema ? `${colorsSchema[3]}20` : "bg-blue-100"
    },
    {
      title: "Le Mie Richieste di Assistenza",
      description: "Visualizza e gestisci le tue richieste",
      icon: "fi fi-br-ticket",
      link: "/customerAssistanceRequests",
      bgColor: colorsSchema ? colorsSchema[4] : "#10b981",
      iconBg: colorsSchema ? `${colorsSchema[4]}20` : "bg-green-100"
    },
    {
      title: "I Miei Impianti",
      description: "Gestisci i tuoi impianti",
      icon: "fi fi-br-settings",
      link: "/customerSystems",
      bgColor: colorsSchema ? colorsSchema[5] : "#f59e0b",
      iconBg: colorsSchema ? `${colorsSchema[5]}20` : "bg-amber-100"
    }
  ];

  return (
    <div className="container p-4 md:p-6 max-w-7xl mx-auto">
      <h1 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 mt-12 md:mt-0">Dashboard Cliente</h1>
      
      <div className="box p-4 md:p-6">
        <h2 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">Benvenuto nella tua area riservata</h2>
        <p className="mb-4 text-sm md:text-base">
          Da qui puoi gestire le tue richieste di assistenza e visualizzare i tuoi dati.
        </p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 mt-6 md:mt-8">
          {cards.map((card, index) => (
            <Link 
              key={index}
              to={card.link}
              className="box !p-6 flex flex-col items-center hover:shadow-lg transition-shadow duration-300 cursor-pointer group"
            >
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300"
                style={{ backgroundColor: card.iconBg }}
              >
                <i 
                  className={`${card.icon} text-2xl`}
                  style={{ color: card.bgColor }}
                ></i>
              </div>
              <h3 className="font-semibold text-lg text-center mb-2">{card.title}</h3>
              <p className="text-sm text-gray-500 text-center">
                {card.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CustomerDashboard;
